import { useAuthStore } from "@/state/pinia";

export default (to, from, next, personTypeId) => {
    const authStore = useAuthStore();

    if (!authStore.loggedIn) {
        next({ name: 'login' });
        return;
    }

    const user = authStore.getUser;
    const personTypeIds = Array.isArray(personTypeId)
        ? personTypeId
        : String(personTypeId ?? '').split('|');

    const normalizedPersonTypeIds = personTypeIds
        .map((id) => String(id ?? '').trim())
        .filter(Boolean);

    const hasAnyPersonType = normalizedPersonTypeIds.some((id) => user.hasPersonTypeId(id));

    if (!normalizedPersonTypeIds.length || !hasAnyPersonType) {
        next({ name: 'Error-404' });
        return;
    }
};
